import axios from "axios";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import swal from "sweetalert";

const Interest = () => {
  const [interests, setInterestType] = useState([]);
  const [loading, setLoading] = useState(true);
  const [infoBuffer, setInfoBuffer] = useState(false);
  useEffect(() => {
    axios.get(`/api/user/interest/type`).then((res) => {
      if (res.status === 200) {
        setInterestType(res.data.allinteresttypes);
        setIsCheck(res.data.interest_topic_id);
        setLoading(false);
      }
    });
  }, []);
  const [peopleInfo, setPeopleInfo] = useState({});
  const [isCheck, setIsCheck] = useState([]);
  const [isCheckAll, setIsCheckAll] = useState(false);

  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(interests.map((li) => li.id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };

  const handleClick = (e) => {
    const { id, checked } = e.target;
    setIsCheck([...isCheck, parseInt(id)]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== parseInt(id)));
    }
  };

  const interestHandle = (e) => {
    e.preventDefault();
    setInfoBuffer(true);
    const formData = new FormData();

    formData.append("interest_topic_id", JSON.stringify(isCheck));
    //add member to group
    axios.post(`/api/user/interest/store`, formData).then((res) => {
      setInfoBuffer(false);
      if (res.data.status === 200) {
        swal("Operation Successful", res.data.message, "success");
      }
    });
  };

  return (
    <>
      <div className="row mx-1 col-sm-12 col-md-12 col-lg-12 justify-content-between ">
        <Form className="text-light">
            <h5 className="text-light text-left">Interest Information</h5>
            <div className="under-line-x mb-3 mt-1"></div>
          <Form.Group
            className=" text-warning "
            controlId="formBasicCheckbox"
          >
            <Form.Check
              type="checkbox"
              onChange={handleSelectAll}
              checked={interests.length == isCheck.length}
              label="Select All"
            />
          </Form.Group>
          {/*<div className="under-line-x mb-3 mt-1"></div>*/}

          {loading ? (
            <SkeletonTheme baseColor="#202020" highlightColor="#444">
              <div className="row">
                {[4].map((data) => (
                  <>
                    <div className="col-md-3 mb-3">
                      <div className="rounded">
                        <div className="bg-dark py-2 px-2 text-left rounded">
                          <Skeleton count={1} width="100%" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3">
                      <div className="rounded">
                        <div className="bg-dark py-2 px-2 text-left rounded">
                          <Skeleton count={1} width="100%" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3">
                      <div className="rounded">
                        <div className="bg-dark py-2 px-2 text-left rounded">
                          <Skeleton count={1} width="100%" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3">
                      <div className="rounded">
                        <div className="bg-dark py-2 px-2 text-left rounded">
                          <Skeleton count={1} width="100%" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3">
                      <div className="rounded">
                        <div className="bg-dark py-2 px-2 text-left rounded">
                          <Skeleton count={1} width="100%" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3">
                      <div className="rounded">
                        <div className="bg-dark py-2 px-2 text-left rounded">
                          <Skeleton count={1} width="100%" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3">
                      <div className="rounded">
                        <div className="bg-dark py-2 px-2 text-left rounded">
                          <Skeleton count={1} width="100%" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3">
                      <div className="rounded">
                        <div className="bg-dark py-2 px-2 text-left rounded">
                          <Skeleton count={1} width="100%" />
                        </div>
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </SkeletonTheme>
          ) : (
            <div className="row ">
              {interests.map((event) => (
                <Form.Group
                  className="col-md-3 mb-3"
                  controlId="formBasicCheckbox"
                >
                  <Form.Check
                    type="checkbox"
                    key={event.id}
                    id={event.id}
                    name={event.name}
                    onChange={handleClick}
                    label={event.interest_type}
                    checked={isCheck.includes(event.id)}
                  />
                </Form.Group>
              ))}
            </div>
          )}

          <div className="col-sm-12 col-md-8 mb-3 justify-content-center my-3 ">
            <div className="col-md-4">
              {loading ? (
                <>
                  <button className="form-control form-control-sm account-input-style">
                    <i className="fas fa-spinner fa-pulse"></i>
                  </button>
                </>
              ) : (
                <button
                  className="btn BTnInfo w-100 fw-bold"
                  type="submit"
                  onClick={interestHandle}
                >
                  {infoBuffer ? (
                    <>
                      <i className="fas fa-spinner fa-pulse"></i>&nbsp;
                    </>
                  ) : (
                    <></>
                  )}
                  Save
                </button>
              )}
            </div>
          </div>
        </Form>
      </div>
    </>
  );
};

export default Interest;
